import type { OpenAPI } from "simplydo/interfaces";
import { Loader } from "simplydo/react/ui/loader";

import { useChildIdea } from "components/ideas/hooks/useIdea";

import { ImpactStatementEditor } from "./ImpactStatementEditor";

type ImpactStatementProps = {
  forStage: OpenAPI.Schemas["ImpactStatement"]["stage"];
  editable?: boolean;
};

const IdeaImpactStatement = ({ forStage, editable }: ImpactStatementProps) => {
  const [idea, ideaQuery] = useChildIdea();

  if (ideaQuery.isLoading) {
    return <Loader />;
  }

  if (!idea?._id) {
    return null;
  }

  return (
    <ImpactStatementEditor
      ideaId={idea._id}
      editable={editable}
      forStage={forStage}
    />
  );
};

export default IdeaImpactStatement;
